import Handle from '~/prix/react/components/handle'
import styled from 'styled-components'
import { PulseLoader } from 'react-spinners'
import { AppError } from '~/prix'
import { OverlayLoading } from '~/packages/sentinel/styles/overlayLoading'
import LoadingMessage from '~/prix/react/components/loadingMessage'

const sentinelLoadingMessages = [
  'Pesquisando por informações da área selecionada',
  'Resgatando dados referentes à área selecionada',
  'Carregando quantitativos da área selecionada',
  'Relacionando dados para gerar os insights',
  'Organizando as visualizações do mapa',
]

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;

  .legends-desktop {
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      display: none;
    }
  }
`

type WrapperScreenProps = {
  isLoadingScreen: boolean
  error: Error | AppError | null
  isLoadingFeature: boolean
  children: React.ReactNode
}

export const BaseWrapperScreen = ({
  isLoadingFeature,
  isLoadingScreen,
  error,
  children,
}: WrapperScreenProps) => {
  return (
    <Handle isLoading={isLoadingScreen} error={error}>
      <Wrapper>
        {children}
        {isLoadingFeature ? (
          <OverlayLoading>
            <div className='center'>
              <PulseLoader color='#fff' />
              <div className='message'>
                <LoadingMessage messages={sentinelLoadingMessages} />
              </div>
            </div>
          </OverlayLoading>
        ) : null}
      </Wrapper>
    </Handle>
  )
}
